import script from "./DeleteConfirmationDialogComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteConfirmationDialogComponent.vue?vue&type=script&setup=true&lang=js"

import "./DeleteConfirmationDialogComponent.vue?vue&type=style&index=0&id=6b785352&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b785352"]])

export default __exports__